import { SupportedResolution } from '../types';

export function getNextBarTime(
  barTime: number, // ms
  resolution: SupportedResolution,
): number {
  const date = new Date(barTime);

  switch (resolution) {
    case '1':
      date.setMinutes(date.getMinutes() + 1);
      break;
    case '5':
      date.setMinutes(date.getMinutes() + 5);
      break;
    case '15':
      date.setMinutes(date.getMinutes() + 15);
      break;
    case '60':
      date.setHours(date.getHours() + 1);
      break;
    case '240':
      date.setHours(date.getHours() + 4);
      break;
    case '1D':
      date.setDate(date.getDate() + 1);
      break;
    case '1W':
      date.setDate(date.getDate() + 7);
      break;
    default:
      throw new Error('Invalid resolution');
  }

  return date.getTime();
}
